var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-5 inline-block inline-flex flex-col px-2 justify-center",class:_vm.backgroundClasses},[_c('p',{staticClass:"font-semibold",class:_vm.textClasses},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }